// extracted by mini-css-extract-plugin
export default {"distinction":"_e49aa55c","copy":"_96d2ce2b","icon":"_3e84a045","tooltipText":"_9c266de6"};